import React from 'react';
import image404Png from './image404.png';

export default function Image404() {
    return (
        <div className="img404">
            <img src={image404Png} alt="Copy room code"/>
        </div>
    )
}